<section class="blog blog-grid pt-70 pb-90">
    <div class="container pairblank">
       <div class="row" >
            <div class="col-sm-12 col-md-12 col-lg-8 mb-30-xs mb-30-sm" >
                <div>
                    <h1 class="info-detail-title" i18n="@@analysis"> Halka Arz ve Hisse Analizleri
                    </h1>
                </div>
                <div class="row">
                    <ng-template ngFor let-analysis [ngForOf]="analysisList" let-i="index" [ngForTrackBy]="trackByFnA">
                        <div class="col-sm-12 col-md-6 col-lg-6 wow fadeIn" data-wow-delay="100ms">
                            <div class="col-12 col-md-12 order-1 order-md-2  p-0 p-md-2">
                                <div class="aspect-ratio-container-sd info-imgsd">
                                    <a [routerLink]="['/analysis',analysis?.url]" title="{{analysis?.title}}">
                                        <div class="col-4"style="width:auto;height:auto;">
                                            <picture>
                                                <source media="(max-width: 90px)" srcset="{{domainURL}}halka-arz-0.webp" />
                                                <source media="(min-width: 90px)" srcset="{{domainURL}}halka-arz-0.webp" />
                                                <img loading="lazy" class="bd-placeholder-img aspect-ratio-item"
                                                data-src="{{domainURL}}halka-arz-{{(i+1)%6}}.webp"
                                                alt="{{analysis?.title}}" title="{{analysis?.title}}">
                                        <div class="entry--overlay"></div></picture></div>
                                    </a>
                                </div>
                            </div>
                            <div class="blog-entry px-2">
                                <div class="entry--content">
                                    <div class="entry--title">
                                        <h2 class="info-title">
                                            <a [routerLink]="['/analysis',analysis?.url]" title="{{analysis?.title}}">{{analysis?.title}}</a>
                                        </h2>
                                    </div>
                                    <div class="entry--bio" style="text-align: left;">
                                        {{analysis?.subTitle}}
                                    </div>
                                    <span class="entry--date">{{analysis.createDate | date: 'EEEE, MMMM d, y'}}</span>
                                    <div class="entry--footer">
                                        <div class="entry--more href-wrap">
                                            <a [routerLink]="['/analysis',analysis?.url]" title="{{analysis?.title}}"  class="href">
                                                <fa-icon [icon]="faPlus" aria-hidden="true" class="header-icons" style="font-size: 17px;"></fa-icon>
                                                Devamını oku
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
                <div class="row" style="margin-top: 20px;">
                    <div class="col-sm-12 col-md-12 col-lg-12 clearfix mt-10 text--center">
                        <app-mansel-pagination [pageIn]="pageInfo" (setManselPaginePageEvent)="setPage($event)">
                        </app-mansel-pagination>
                    </div>
                </div>
                <div class="widget market-pricing market-list card mb-3" style="position: relative; padding:10px;">
                    <div class="row pt-70">
                    <div class="col-4"style="width:auto;height:auto;">
                        <picture>
                            <source media="(max-width: 192px)" srcset="{{domainURL}}halka-arz.webp" />
                            <source media="(min-width: 192px)" srcset="{{domainURL}}halka-arz.webp" />
                            <img loading="lazy" width="192px" height="108px" src="{{domainURL}}halka-arz.webp" alt="Halka Arz ve Hisse Analizleri" title="Halka Arz ve Hisse Analizleri">
                        </picture></div>
                    <div class="col-8"><strong>Halka Arz ve Hisse Analizleri</strong>, hisselerin ve borsa haberlerinin analizlerini bu sayfadan okuyabilirsiniz. </div>
                    <div class="w-100"></div>
                    <br>
                    <h5 style="color: black;font-size:medium">Halka Arz Nedir?</h5>
                    <p>Halka arz, şirketlerin hisse senetlerini veya tahvil gibi finansal araçlarının-menkul kıymetlerinin- halka satışıdır. Halka Arz edilen bu finansal araçlar adi veya imtiyazlı hisseler gibi öz sermaye paylarını ya da tahvil gibi alınıp satılabilen diğer varlıkları içerebilir. </p>
                    <br>
                    </div>
                    <p>Halkaarz info adresinden yorumcularımızın kişisel yorumlarını takip eder, güvenilir kaynaklardan piyasa hakkında bilgi alabilir ve kendi mali sürecinizi yönetebilirsiniz.</p>
                    <p>Halka arz analizleri yazılarımızı okumak ve güncel hisse analizlerine ulaşmak için <a [routerLink]="['/analysis']" title="Halka Arz Analiz" >"Halka Arz Analiz" sayfamızı ziyaret edebilirsiniz.</a></p>
                    <p>Güncel Halka Arz olacak şirketleri takip etmek için <a [routerLink]="['/ipo-calendar']" title="Halka Arz Takvimi" >"Halka Arz Takvimi"</a> sayfamızı ziyaret edebilirsiniz.</p>
                    <p>Hissenize düşen ve <a [routerLink]="['/dividend']" title="Temettü Hisseleri" >"Temettü Hisseleri"</a> sayfamızı ziyaret edebilirsiniz.</p>
                    <p>Borsa'da sıkça kullanılan terimler hakkından bilgi edinmek için <a  [routerLink]="['/info']" title="Gerekli Bilgiler" >"Gerekli Bilgiler"</a> sayfamızı ziyaret edebilirsiniz</p>
                    <p>Temettü oranlarını hesaplamak için <a [routerLink]="['/calculate']" title="Temettü Hesaplama" >"Temettü Hesaplama"</a> aracımızı kullanabilirsiniz.</p>
                    <p>Hisse analizleri anketlerine katılmak için <em><a href="https://www.whatisproblem.com/tr/hisse-z3r3bYnCC4LaCrAaKK26" title="whatisproblem.com">whatisproblem.com</a></em>'u takip edebilirsiniz</p>
                    <h6 style="font-size:small">Halka Arz ve Hisse Analizleri yazılarına bu sayfadan ulaşabilirsiniz.</h6>
                  </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4">
               <app-draft-month [toYear]="year"></app-draft-month>
               <app-draft-dividend [toYear]="year"></app-draft-dividend>
               <app-summary-info></app-summary-info>
            </div>
        </div>
    </div>
</section>
